// textarea/input 안에서 캐럿(커서)의 픽셀 위치를 구한다 — 파워모드 파티클을 커서 위치에서 터뜨리기 위함.
// 표준 "mirror div" 기법: 동일한 폰트/패딩/보더를 가진 숨은 div를 만들어 캐럿 앞 텍스트를 복제,
// 마지막 지점(span)의 offset을 읽는다. (component/textarea-caret-position 기반, 경량화)
//
// 반환: { top, left, height } — 대상 엘리먼트의 padding-box 기준(스크롤 미반영, 호출측에서 scrollTop/Left 차감).

// mirror에 복제해야 하는 계산된 스타일 속성들
const MIRRORED_PROPS = [
  "direction",
  "boxSizing",
  "width",
  "height",
  "overflowX",
  "overflowY",
  "borderTopWidth",
  "borderRightWidth",
  "borderBottomWidth",
  "borderLeftWidth",
  "borderStyle",
  "paddingTop",
  "paddingRight",
  "paddingBottom",
  "paddingLeft",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "fontStretch",
  "fontSize",
  "fontSizeAdjust",
  "lineHeight",
  "fontFamily",
  "textAlign",
  "textTransform",
  "textIndent",
  "textDecoration",
  "letterSpacing",
  "wordSpacing",
  "tabSize",
  "MozTabSize",
];

export function getCaretCoordinates(element, position) {
  const isInput = element.nodeName === "INPUT";
  const doc = element.ownerDocument;
  const win = doc.defaultView || window;

  const div = doc.createElement("div");
  div.id = "power-mode-caret-mirror";
  doc.body.appendChild(div);

  const style = div.style;
  const computed = win.getComputedStyle(element);

  style.whiteSpace = "pre-wrap";
  if (!isInput) style.wordWrap = "break-word";
  style.position = "absolute";
  style.visibility = "hidden";

  MIRRORED_PROPS.forEach((prop) => {
    if (isInput && prop === "lineHeight") {
      // input은 단일 줄 → lineHeight를 height로 대체(수직 정렬 일치)
      if (computed.boxSizing === "border-box") {
        const h = parseInt(computed.height, 10);
        const inner =
          h -
          parseInt(computed.paddingTop, 10) -
          parseInt(computed.paddingBottom, 10) -
          parseInt(computed.borderTopWidth, 10) -
          parseInt(computed.borderBottomWidth, 10);
        style.lineHeight = inner + "px";
      } else {
        style.lineHeight = computed.height;
      }
    } else {
      style[prop] = computed[prop];
    }
  });

  // input은 스크롤 대신 overflow hidden 처리
  style.overflow = "hidden";

  div.textContent = element.value.substring(0, position);
  if (isInput) div.textContent = div.textContent.replace(/\s/g, " ");

  const span = doc.createElement("span");
  // 캐럿 뒤 최소 1글자 → 줄바꿈 처리 안정화
  span.textContent = element.value.substring(position) || ".";
  div.appendChild(span);

  const coordinates = {
    top: span.offsetTop + parseInt(computed.borderTopWidth, 10),
    left: span.offsetLeft + parseInt(computed.borderLeftWidth, 10),
    height: parseInt(computed.lineHeight, 10) || parseInt(computed.fontSize, 10),
  };

  doc.body.removeChild(div);
  return coordinates;
}
